<template>
  <div>
    <nav class="flex items-center justify-between flex-wrap bg-teal-500 p-6">
      <div class="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
        <div class="text-sm lg:flex-grow">
          <div class="font-semibold text-4xl tracking-tight text-white">Flashcard 列表</div>
        </div>
      </div>
    </nav>
    <ul class="list-disc">
      <li v-for="card in cards" :key="card.name">
        <a
          class="text-2xl underline text-green-700 hover:text-green-900"
          :href="'/' + card.path"
        >{{ card.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import cards from "../data/cards";

function getCards() {
  let cardInfos = [];
  for (let key in cards) {
    let info = {};
    info["name"] = cards[key].name;
    info["path"] = key;
    cardInfos.push(info);
  }
  return cardInfos;
}

export default {
  name: "Home",
  data() {
    return {
      cards: getCards()
    };
  },
  mounted() {
    this.$ga.page("/");
  },
  methods: {
    track() {
      this.$ga.page("/");
    }
  }
};
</script>

<style scoped></style>
